







import { Vue, Component } from "@/shared/vuepack";
import { useOutageNotificationStore } from "@/shared/store/outageNotification";

@Component
export default class OutageNotificationBanner extends Vue {

  outageNotificationStore = useOutageNotificationStore();

  get showNotification (): boolean {
    return this.outageNotificationStore.outageNotification && this.outageNotificationStore.outageNotification.enabled || false;
  }

  get notificationMessage (): string {
    return this.outageNotificationStore.outageNotification && this.outageNotificationStore.outageNotification.message;
  }

  created () {
    this.outageNotificationStore.loadOutageNotification();
  }
}

